import gsap from 'gsap'
import MorphSVGPlugin from 'gsap/MorphSVGPlugin'
import { body } from './utils/environment'

gsap.registerPlugin(MorphSVGPlugin)

// eslint-disable-next-line import/prefer-default-export
export function preloader() {
  const preloaderIcon = document.querySelector('.c-preloader_icon svg #iconInitial')
  const menuItems = document.querySelectorAll('.c-nav_list_item_link_text')

  const mm = gsap.matchMedia()

  // --------------------------------------------------
  // Mobile Preloader
  // --------------------------------------------------

  mm.add('(max-width: 1023px)', () => {
    const homeMobileTimeline = () => {
      if (body.classList.contains('home')) {
        gsap.timeline()
          .set(['.c-menu-toggler', '.c-header_logo', '.c-header_link'], {
            autoAlpha: 0,
          })
          .set(menuItems, {
            y: '200%',
            skewY: 7,
          })
          .to(menuItems, {
            delay: 1,
            y: 0,
            skewY: 0,
            duration: 0.7,
            stagger: 0.1,
            ease: 'power2.out',
          })
          .to(['.c-menu-toggler', '.c-header_logo', '.c-header_link'], {
            duration: 0.4,
            autoAlpha: 1,
            stagger: 0.1,
            ease: 'linear',
          })
      } else {
        gsap.timeline()
          .set(['.c-menu-toggler', '.c-header_logo', '.c-header_link'], {
            autoAlpha: 0,
          })
          .set('[data-barba="wrapper"]', {
            autoAlpha: 0,
          })
          .to('[data-barba="wrapper"]', {
            delay: 1,
            autoAlpha: 1,
            duration: 0.7,
            ease: 'linear',
          })
          .to(['.c-menu-toggler', '.c-header_logo', '.c-header_link'], {
            duration: 0.4,
            autoAlpha: 1,
            stagger: 0.1,
            ease: 'linear',
          })
      }
    }

    gsap.timeline()
      .to('.c-preloader_icon svg', {
        attr: {
          viewBox: '0 0 53 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence1' },
      }, '-=0.4')
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence2' },
      })
      .to('.c-preloader_icon svg', {
        attr: {
          viewBox: '0 0 40 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence3' },
      }, '-=0.4')
      .to('.c-preloader_icon svg', {
        attr: {
          viewBox: '0 0 53 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence4' },
      }, '-=0.4')
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence5' },
      })
      .to('.c-preloader_icon svg', {
        scale: 0.5,
        duration: 0.7,
        ease: 'power2.inOut',
      })
      .to('.c-preloader_text', {
        duration: 0.7,
        ease: 'power2.inOut',
        height: 'auto',
        onComplete: homeMobileTimeline,
      }, '-=0.7')
      .to('.c-preloader', {
        duration: 0.7,
        ease: 'linear',
        backgroundColor: 'transparent',
      })
      .to('.c-preloader_icon svg', {
        duration: 0.7,
        ease: 'power2.inOut',
        autoAlpha: 0,
        y: '-250px',
      })
      .to('.c-preloader_text', {
        duration: 0.7,
        ease: 'power2.inOut',
        autoAlpha: 0,
        y: '-250px',
      }, '-=0.7')
      .set('.c-preloader', {
        display: 'none',
      })
  })

  // --------------------------------------------------
  // Desktop Preloader
  // --------------------------------------------------

  mm.add('(min-width: 1024px)', () => {
    const homeTimeline = () => {
      if (body.classList.contains('home')) {
        gsap.timeline()
          .set(['.c-header_site-name', '.c-header_logo', '.c-header_link'], {
            autoAlpha: 0,
          })
          .set(menuItems, {
            y: '200%',
            skewY: 7,
          })
          .to(menuItems, {
            delay: 1,
            y: 0,
            skewY: 0,
            duration: 0.7,
            stagger: 0.1,
            ease: 'power2.out',
          })
          .to(['.c-header_site-name', '.c-header_logo', '.c-header_link'], {
            duration: 0.4,
            autoAlpha: 1,
            stagger: 0.1,
            ease: 'linear',
          })
      } else {
        gsap.timeline()
          .set(['.c-header_site-name', '.c-header_logo', '.c-header_link'], {
            autoAlpha: 0,
          })
          .set('[data-barba="wrapper"]', {
            autoAlpha: 0,
          })
          .to('[data-barba="wrapper"]', {
            delay: 1,
            autoAlpha: 1,
            duration: 0.7,
            ease: 'linear',
          })

          .to(['.c-header_site-name', '.c-header_logo', '.c-header_link'], {
            duration: 0.4,
            autoAlpha: 1,
            stagger: 0.1,
            ease: 'linear',
          })
      }
    }

    gsap.timeline()
      .to('.c-preloader_icon svg', {
        attr: {
          viewBox: '0 0 53 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence1' },
      }, '-=0.4')
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence2' },
      })
      .to('.c-preloader_icon svg', {
        attr: {
          viewBox: '0 0 40 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence3' },
      }, '-=0.4')
      .to('.c-preloader_icon svg', {
        attr: {
          viewBox: '0 0 53 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence4' },
      }, '-=0.4')
      .to(preloaderIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence5' },
      })
      .to('.c-preloader_text', {
        duration: 0.7,
        ease: 'power2.inOut',
        width: 'auto',
        onComplete: homeTimeline,
      })
      .to('.c-preloader', {
        duration: 0.7,
        ease: 'linear',
        backgroundColor: 'transparent',
      })
      .to('.c-preloader_inner', {
        duration: 0.7,
        ease: 'linear',
        autoAlpha: 0,
      })
      .set('.c-preloader', {
        display: 'none',
      })
  })
}
